<script>
import { http } from '@/system/http.js';
import Switchery from '@/system/components/global/form/Switchery.vue';
import hasSelectedProducts from '@/online_booking/new/mixins/hasSelectedProducts.js';
import PaymentRateInterval from '@/core/PaymentRate/PaymentRateInterval';
import ClientAddressInfo from '@/online_booking/new/components/common_booking/ClientAddressInfo.vue';
import moment from 'moment';
import Card from '@/online_booking/new/components/common/Card';
import {mapActions, mapGetters, mapState} from 'vuex';
import PreviousButton from '@/online_booking/new/components/common/PreviousButton.vue';
import StepCounter from '@/online_booking/new/components/common/StepCounter';
import EpButton from '@/system/components/global/button';

export default {
    data() {
        return {
            PaymentRateInterval,
            calendar: null,
            time: null,
            info: null,
            dataFrm: null,
            permalink: null,
            online_booking_settings: {},
            user: {},
            conditions_accept: false,
            consent_accepted: false,
            mailchimp_subscribe: false,
            logged_in_client: null,
            loading: false,
            is_consent_enabled: false,
            consent_settings: null,
            isWaitingList: false,
            voucher: null,
            payment_rate_request: 0,
            waiting_list_comments: '',
            fullDaySignup: 0,
            currency: Config.get('countries.' + locale + '.currency'),
        }
    },

    mixins: [hasSelectedProducts],

    mounted() {
        this.$event_bus.$on('LoadData', (data) => {
            this.permalink = data.permalink;
            this.online_booking_settings = data.online_booking_settings;
            this.user = data.user;
            this.logged_in_client = data.logged_in_client;
            this.is_consent_enabled = data.is_consent_enabled;
            this.consent_settings = data.consent_settings;
        });

        this.$event_bus.$on('CalendarClicked', (calendar) => {
            this.calendar = calendar;
        });

        this.$event_bus.$on('voucherClicked', (voucher) => {
            this.voucher = voucher;
        });

        this.$event_bus.$on('timeSet', (time, fullyBooked, waitingList) => {
            this.time = time.date;
            this.isWaitingList = waitingList;
        });

        this.$event_bus.$on('preferredTimeSet', (selected_time, fullDaySignup, comments, fullyBooked, waitingList) => {
            this.time = selected_time;
            this.waiting_list_comments = comments;
            this.fullDaySignup = fullDaySignup;
            this.isWaitingList = waitingList;
        });

        this.$event_bus.$on('confirm', (data) => {
            this.dataFrm = data.dataFrm;
            this.info = data.confirmInfo;
            this.isWaitingList = data.isWaitingList;

            this.$nextTick(function () {
                this.triggerStateChange()
            });

        });

        this.$event_bus.$on('bookSoonest', (soonestData) => {
            this.calendar = soonestData.calendar;
        });

    },

    methods: {
        ...mapActions('OnlineBooking', ['setCurrentStep']),

        approve(pay_now) {
            this.errors.clear();
            this.dataFrm.append('pay_now', pay_now);
            this.dataFrm.append('payment_rate_request', this.payment_rate_request);

            if (this.online_booking_settings.conditions_accept) {
                this.dataFrm.append('conditions_accept', this.conditions_accept);
            }

            if (this.consent_accepted) {
                this.dataFrm.append('consent_accepted', this.consent_accepted);
            }

            if (this.giftcard) {
                this.dataFrm.append('giftcard_id', this.giftcard.id);
            }

            if (this.discount_code) {
                this.dataFrm.append('discount_code_id', this.discount_code.id);
            }

            if (this.showMailchimp) {
                this.dataFrm.append('mailchimp_subscribe', this.mailchimp_subscribe);
            }

            if (this.isWaitingList || this.waitingListOnly) {
                this.dataFrm.append('is_waiting_list', this.isWaitingList);
                this.dataFrm.append('waiting_list_comments', this.waiting_list_comments);
            }

            this.loading = true;

            http.post('/book/' + this.permalink + '/choose-client', this.dataFrm)
                .then(({data}) => {
                    if (data.payment) {
                        this.$event_bus.$emit('payment', {data: data, dataFrm: this.dataFrm});
                        /* Fix a bug where the loader keeps spinning forever:
                        ** we have to set loading to false here,
                        ** because we have a payment step next,
                        ** and if the client chooses to go back from the payment step
                        ** the loader just keeps on spinning forever
                        */
                        this.loading = false;
                    } else {
                        this.$event_bus.$emit('finish', data);
                        /* Fix a bug where multiple waiting list entries were being created: fix by joel
                        ** we have to set loading to true here,
                        ** because it quickly fixed the bug where multiple waiting list entries were being created
                        ** this could be changed later, when we have found why the bug was happening
                        */
                        this.loading = true;
                    }
                })
                .catch(({error, errorBag}) => {
                    this.loading = false;

                    if (errorBag) {
                        this.$setErrorBag(errorBag);
                    }
                });

        },

        approveVoucher(pay_now) {
            this.loading = true;
            this.errors.clear();
            this.dataFrm.append('pay_now', pay_now);

            if (this.online_booking_settings.conditions_accept) {
                this.dataFrm.append('conditions_accept', this.conditions_accept);
            }

            if (this.consent_accepted) {
                this.dataFrm.append('consent_accepted', this.consent_accepted);
            }

            this.dataFrm.append('payment_rate_request', this.payment_rate_request );

            if (this.showMailchimp) {
                this.dataFrm.append('mailchimp_subscribe', this.mailchimp_subscribe);
            }

            if (this.discount_code) {
                this.dataFrm.append('discount_code_id', this.discount_code.id);
            }

            http.post('/voucher/' + this.voucher.id + '/choose-client', this.dataFrm)
                .then(({data}) => {
                    if (data.payment) {
                        this.$event_bus.$emit('payment', {data: data, dataFrm: this.dataFrm});
                    } else {
                        this.$event_bus.$emit('finish', data);
                    }
                    this.loading = false;
                })
                .catch(({errorBag}) => {
                    this.loading = false;
                    if (errorBag) {
                        this.$setErrorBag(errorBag);
                    }
                });
        },

        loaderOn() {
            this.loading = true;
        },

        triggerStateChange() {
            this.setCurrentStep('confirmation');
        },
    },

    computed: {
        ...mapState('OnlineBooking', ['currentStep']),
        ...mapGetters('OnlineBooking', ['getPreviousStepId', 'currentStepNumber', 'totalStepCount', 'waitingListOnly']),

        has_business_location() {
            if (this.calendar && this.calendar.business_location) return true

            return false
        },

        should_show_payment_rates_option() {
            if (!this.user.is_payment_rates_active) {
                return false;
            }

            if (this.isWaitingList) {
                return false;
            }

            //Wants to buy a voucher
            if (this.isBuyVouchersPage && this.voucher && this.voucher.payment_rates && this.totalPriceToPayNow > 0) {
                return true;
            }

            //Wants to book a time
            if (this.hasSelectedProducts && this.productsWithPaymentRates.length && this.selectedProducts.length === this.productsWithPaymentRates.length) {

                if (this.payableProducts.length && this.selectedProducts.length > 1) {
                    return false;
                }

                if (this.totalProductsPriceWithGiftcard <= 0) {
                    return false;
                }

                return true;
            }

            return false;
        },

        isBuyVouchersPage() {
            return this.$route.name === 'buy-vouchers';
        },

        showMailchimp() {
            return this.user.is_mailchimp_connected && this.online_booking_settings.show_mailchimp_subscribe;
        },

        totalAppointmentTime() {
            if (this.totalAddonProductsDurationInMinutes != 0) {
                return this.totalProductsDurationInMinutes + this.totalAddonProductsDurationInMinutes
            }

            return this.totalProductsDurationInMinutes
        },

        booking_start() {
            if (this.time) {
                return moment(this.time).locale(moment_locale).format('dddd LL, HH:mm');
            }

            return null;
        },

        booking_end() {
            if (this.time && this.hasSelectedProducts) {
                return moment(this.time).add(this.totalAppointmentTime, 'minutes').format('HH:mm');
            }

            return null;
        },

        waiting_list_date() {
            if (this.time) {
                return moment(this.time).locale(moment_locale).format('LL');
            }

            return null;
        },

        consent_required() {
            return this.is_consent_enabled
                && (this.hasSelectedProducts && !this.voucher ? this.consent_settings.required_online_booking : true)
                && (this.voucher ? this.consent_settings.required_vouchers : true)
                && (!this.logged_in_client || (this.logged_in_client && (!this.logged_in_client.consent || this.logged_in_client.consent.is_consent_outdated)));
        },

        canReservePayment() {
            return this.reservableProducts.length > 0;
        },

        isConfirmBookingActive () {
            return this.currentStep === 'confirmation';
        },

    },

    components: {
        Switchery,
        ClientAddressInfo,
        Card,
        PreviousButton,
        StepCounter,
        EpButton,
    },

    watch: {
        isConfirmBookingActive (newValue) {
            if (newValue) {
                this.$event_bus.$emit('ConfirmShowed');
                window.location.hash = 'confirm-booking';
            }
        }
    },
};

</script>


<template>
    <div class="products-container" v-show="isConfirmBookingActive">
        <form class="form-horizontal" role="form">
            <card class="p-0 overflow-hidden rounded-lg" id="confirm-booking-panel">
                <h4 class="section-title" v-if="!isWaitingList">
                    <step-counter :total="totalStepCount" :current="currentStepNumber" />
                    {{ $route.name === 'online-booking' ? trans('events.receipt_extended') : trans('events.receipt') }}
                </h4>
                <h4 class="section-title" v-else>
                    <step-counter :total="totalStepCount" :current="currentStepNumber" />
                    {{ trans('waiting_list.confirm_waiting_list_title') }}
                </h4>

                <div
                    id="collapseConfirm"
                    role="tabpanel"
                    aria-labelledby="headingFive"
                    data-parent="#booking-accordion"
                >
                    <div class="panel-body" id="confirm-body-booking">
                        <div class="row" v-if="isWaitingList">
                            <div class="col-xs-12">
                                <ep-banner>
                                    <strong>{{ trans('online_booking.waiting_list_notification') }}</strong><br>
                                    {{
                                        waitingListOnly
                                            ? trans('waiting_list.email.confirmation_info_2_no_preferred_time')
                                            : trans('waiting_list.email.confirmation_info_2')
                                    }}
                                </ep-banner>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-xs-12">
                                <div class="form-group m-b-10" v-if="time && !isBuyVouchersPage">
                                    <label v-if="!isWaitingList" class="col-sm-3 control-label mb-0">{{ trans('online_booking.receipt_time') }}</label>
                                    <label v-else class="col-sm-3 control-label mb-0">{{ trans('waiting_list.preferred_time') }}:</label>
                                    <div class="col-sm-9">
                                        <div class="form-control-static" v-if="time && !fullDaySignup">{{ booking_start }} - {{ booking_end }} <span>{{ $root.tzOffset }}</span></div>
                                    </div>
                                    <!-- just show the selected date if it's a waiting list signup without preferred time -->
                                    <div class="col-sm-9">
                                        <div class="form-control-static" v-if="time && fullDaySignup">{{ waiting_list_date }}</div>
                                    </div>
                                </div>

                                <div class="form-group m-b-10" v-if="has_business_location">
                                    <label class="col-sm-3 control-label mb-0">{{ trans('calendar.calendar_type_location') }}</label>

                                    <div class="col-sm-9">
                                        <div class="form-control-static" >{{ calendar.business_location }}</div>
                                    </div>
                                </div>

                                <div class="form-group m-b-10" v-if="voucher">
                                    <label class="col-sm-3 control-label mb-0">{{ trans('vouchers.title') }}</label>
                                    <div class="col-sm-9">
                                        <div class="form-control-static">{{ voucher.name }}</div>
                                    </div>
                                </div>

                                <div class="form-group m-b-10" v-if="voucher">
                                    <label class="col-sm-3 control-label mb-0">{{ trans('vouchers.number_of_uses') }}</label>
                                    <div class="col-sm-9">
                                        <div class="form-control-static">{{ voucher.clips }}</div>
                                    </div>
                                </div>

                                <div class="form-group m-b-10" v-if="!waitingListOnly && isWaitingList && waiting_list_comments">
                                    <label class="col-sm-3 control-label mb-0">{{ trans('online_booking.fill_notes') }}</label>
                                    <div class="col-sm-9">
                                        <div class="form-control-static">{{ waiting_list_comments }}</div>
                                    </div>
                                </div>

                                <div class="form-group m-b-10" v-if="!isBuyVouchersPage">
                                    <label class="col-sm-3 control-label mb-0" v-text="selectedProducts.length > 1 ? trans('global.products') : trans('global.product')"></label>
                                    <div class="col-sm-9">
                                        <div class="form-control-static">
                                            <div v-for="(product, index) in selectedProducts" :key="index">
                                                <span>{{ product.name }}</span>
                                                <span v-if="product.selectedAddons && product.selectedAddons.length > 0" v-text="`(+ ${product.selectedAddons.map(a => a.name).join(', ')})`" class="text-muted"></span>
                                            </div>
                                            <div v-if="voucher">{{ voucher.product.name }}</div>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group m-b-10" v-if="(totalPrice > 0 || isBuyVouchersPage) && !isWaitingList">
                                    <label class="col-sm-3 control-label mb-0">{{ trans('global.price') }}</label>
                                    <div class="col-sm-9">
                                        <div class="form-control-static">

                                            <div v-if="isBuyVouchersPage && voucher">
                                                {{ voucher.price_including_vat_formatted }}
                                            </div>
                                            <div v-else>

                                                {{ totalPriceFormatted }}
                                                <span class="text-success" v-if="!giftcardMoneyUsedForThisBooking && !discountMoneyUsedForThisBooking && totalPriceToPayNow > 0">
                                                    ({{ trans('online_booking.to_pay_now') }}: {{ totalPriceToPayNowFormatted }})
                                                </span>

                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group m-b-10" v-if="discount_code && discountMoneyUsedForThisBooking">
                                    <label class="col-sm-3 control-label mb-0">{{ trans('global.discount') }}</label>
                                    <div class="col-sm-9">
                                        <div class="form-control-static">
                                            <div>
                                                - {{ discountMoneyUsedForThisBookingFormatted }}
                                                ({{ discount_code.code }}
                                                {{ discount_code.type == 'percentage' ? discount_code.value + '%' : currency + ' ' + discount_code.value }})
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group m-b-10" v-if="discount_code && discountMoneyUsedForThisBooking">
                                    <label class="col-sm-3 control-label mb-0" v-if="giftcardMoneyUsedForThisBooking">{{ trans('invoice.subtotal') }}</label>
                                    <label class="col-sm-3 control-label mb-0" v-else>{{ trans('invoice.total') }}</label>
                                    <div class="col-sm-9">
                                        <div class="form-control-static">
                                            {{ totalProductsPriceWithDiscountFormatted }}
                                            <span class="text-success" v-if="totalPriceToPayNow > 0 && !giftcardMoneyUsedForThisBooking">
                                              ({{ trans('online_booking.to_pay_now') }}:
                                              {{ totalPriceToPayNowFormatted }})
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group m-b-10" v-if="giftcard && giftcardMoneyUsedForThisBooking">
                                    <label class="col-sm-3 control-label mb-0">{{ trans('giftcards.title') }}</label>
                                    <div class="col-sm-9">
                                        <div class="form-control-static">
                                            <div>- {{ giftcardMoneyUsedForThisBookingFormatted }} ({{ giftcard.name }})</div>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group m-b-10" v-if="giftcard && giftcardMoneyUsedForThisBooking">
                                    <label class="col-sm-3 control-label mb-0">{{ trans('invoice.total') }}</label>
                                    <div class="col-sm-9">
                                        <div class="form-control-static">
                                            {{ finalPriceFormatted }}
                                            <span class="text-success" v-if="totalPriceToPayNow > 0">({{ trans('online_booking.to_pay_now') }}: {{ totalPriceToPayNowFormatted }})</span>
                                        </div>
                                    </div>
                                </div>

                                <client-address-info
                                    v-if="!isWaitingList && info !== null"
                                    :info="info"
                                    :isClientLoggedIn="logged_in_client !== false"
                                ></client-address-info>

                                <div class="form-group m-b-10" v-if="info && info.notes">
                                    <label class="col-sm-3 control-label mb-0">{{ trans('online_booking.fill_notes') }}</label>
                                    <div class="col-sm-9">
                                        <div class="form-control-static truncate" v-sanitize-html="info.notes"></div>
                                    </div>
                                </div>

                                <div class="m-0 form-group m-b-15" v-if="should_show_payment_rates_option">
                                    <div>
                                        <div class="checkbox">
                                            <input id="payment_rate_request" type="checkbox" v-bind:true-value="1" v-bind:false-value="0" name="payment_rate_request" v-model="payment_rate_request">
                                            <label for="payment_rate_request">
                                                <span v-if="hasSelectedProducts && !voucher">{{ trans('online_booking.payment_rates_info') }}</span>
                                                <span v-if="voucher">{{ trans('online_booking.vouchers_payment_rates_info') }}</span>
                                            </label>
                                        </div>
                                        <small class="text-muted" style="display: block;padding-left: 27px;line-height:20px;" v-if="hasProductsWithPaymentRates && !voucher">
                                            {{ trans('online_booking.payment_rates_details', {number: paymentRatesReferenceProduct.payment_rates_number}) }}

                                            <span v-if="paymentRatesReferenceProduct.payment_rates_interval == PaymentRateInterval.Weekly"> {{ trans('online_booking.weekly_payment_rate') }}</span>
                                            <span v-else-if="paymentRatesReferenceProduct.payment_rates_interval == PaymentRateInterval.Monthly"> {{ trans('online_booking.monthly_payment_rate') }}</span>
                                            <span v-else> {{ trans('online_booking.daily_payment_rate', {number: paymentRatesReferenceProduct.payment_rates_interval }) }}</span>
                                            <br>
                                            <span v-if="paymentRatesReferenceProduct.online_payment === 1 && user.is_online_payment_active && user.can_receive_online_payments">{{ trans('online_booking.payment_rates_option_1', {price: totalProductsRatePriceFormatted}) }}</span>
                                            <span v-else-if="paymentRatesReferenceProduct.online_payment > 1 && user.is_online_payment_active && user.can_receive_online_payments">{{ trans('online_booking.payment_rates_option_2', {price: totalProductsRatePriceFormatted}) }}</span>
                                            <span v-else> {{ trans('online_booking.payment_rates_option_3', {name: user.realname, price: totalProductsRatePriceFormatted}) }}</span>
                                        </small>
                                        <small class="text-muted" style="display: block;padding-left: 27px;line-height:20px;" v-if="voucher">
                                            {{ trans('online_booking.vouchers_payment_rates_details', {number: voucher.payment_rates_number}) }}

                                            <span v-if="voucher.payment_rates_interval == PaymentRateInterval.Weekly"> {{ trans('online_booking.weekly_payment_rate') }}</span>
                                            <span v-else-if="voucher.payment_rates_interval == PaymentRateInterval.Monthly"> {{ trans('online_booking.monthly_payment_rate') }}</span>
                                            <span v-else> {{ trans('online_booking.daily_payment_rate', {number: voucher.payment_rates_interval }) }}</span>
                                            <br>
                                            <span v-if="user.is_online_payment_active && user.can_receive_online_payments">{{ trans('online_booking.payment_rates_option_1', {price: totalProductsRatePriceFormatted}) }}</span>
                                            <span v-else>{{ trans('online_booking.payment_rates_option_3', {user: user.realname, price: totalProductsRatePriceFormatted}) }}</span>
                                        </small>
                                    </div>
                                </div>

                                <div class="m-0 form-group m-b-15" v-if="showMailchimp">
                                    <div>
                                        <div class="checkbox">
                                            <input id="mailchimp_subscribe" type="checkbox" name="mailchimp_subscribe" v-model="mailchimp_subscribe">
                                            <label for="mailchimp_subscribe">
                                                {{ trans('online_booking.newsletter_receive') }}
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                <div class="m-0 form-group m-b-15" :class="{ 'has-error' : errors.has('conditions_accept') }" v-if="online_booking_settings.conditions_accept">
                                    <div>
                                        <div class="checkbox">
                                            <input id="conditions_accept" type="checkbox" name="conditions_accept" v-model="conditions_accept">
                                            <label for="conditions_accept">
                                                {{ trans('online_payment.accept_conditions') }}
                                                 <a :href="online_booking_settings.conditions_link" target="_blank">
                                                    {{ trans('online_payment.accept_conditions_link_label') }}
                                                 </a>
                                            </label>
                                        </div>
                                        <span v-show="errors.has('conditions_accept')" class="help-block m-b-0">{{ errors.first('conditions_accept') }}</span>
                                    </div>
                                </div>

                                <div class="m-0 form-group mb-0" :class="{ 'has-error' : errors.has('consent_accepted') }" v-if="consent_required">
                                    <div>
                                        <div class="checkbox">
                                            <input id="consent_accepted" type="checkbox" name="consent_accepted" v-model="consent_accepted">
                                            <label for="consent_accepted">
                                                {{ consent_settings.checkbox_label }}
                                            </label>
                                            <a href="" data-toggle="modal" data-target="#consentModal" >({{ trans('online_booking.read_more') }})</a>
                                        </div>
                                        <span v-show="errors.has('consent_accepted')" class="help-block m-b-0">{{ errors.first('consent_accepted') }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row" v-if="waitingListOnly">
                            <div class="col-xs-12">
                                <h6 class="m-b-10" >{{ trans('online_booking.fill_notes') }} ({{ trans('online_booking.optional') }})</h6>
                                <textarea v-model="waiting_list_comments" name="waiting-list-notes" id="waiting-list-notes" cols="40" rows="3"></textarea>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flex justify-between flex-wrap gap-6 p-6 pt-0">
                    <previous-button :previous-step-id="getPreviousStepId" />
                    <div v-if="hasSelectedProducts && !isBuyVouchersPage">
                        <div v-if="isWaitingList">
                            <ep-button
                                :loading="loading"
                                :disabled="loading"
                                @click="approve(0)"
                            >
                                <i class="zmdi zmdi-check mr-3"></i>
                                <span class="hidden sm:inline">{{ trans('waiting_list.confirm_waiting_list') }}</span>
                                <span class="sm:hidden">{{ trans('global.continue') }}</span>
                            </ep-button>
                        </div>

                        <div v-if="!isWaitingList && totalPriceToPayNow > 0">
                            <ep-button
                                :loading="loading"
                                :disabled="loading"
                                @click="approve(1)"
                            >
                                <i class="zmdi zmdi-card mr-3"></i>
                                <span class="hidden sm:inline">{{ trans('vouchers.confirm_and_pay') }}</span>
                                <span class="sm:hidden">{{ trans('global.continue') }}</span>
                            </ep-button>
                        </div>

                        <div v-if="!isWaitingList && !totalPriceToPayNow">
                            <ep-button
                                :loading="loading"
                                :disabled="loading"
                                @click="approve(0)"
                            >
                                <span>{{ trans('online_booking.confirm_booking') }}</span>
                            </ep-button>
                        </div>

                        <div class="mt-6" v-if="!isWaitingList && totalPriceToPayNow > 0 && productPaymentOptional">
                            <div class="button-divider my-5">
                                <hr>
                                <p>{{ trans('global.or') }}</p>
                                <hr>
                            </div>
                            <ep-button
                                :loading="loading"
                                :disabled="loading"
                                variant="secondary"
                                @click="approve(0)"
                            >
                                <i class="zmdi zmdi-check mr-3"></i>
                                <span class="hidden sm:inline">{{ trans('online_booking.submit_without_payment') }}</span>
                                <span class="sm:hidden">{{ trans('waiting_list.invitation.pay_later') }}</span>
                            </ep-button>
                        </div>
                    </div>
                    <div v-if="voucher">
                        <ep-button
                            v-if="voucher.price === 0"
                            :loading="loading"
                            :disabled="loading"
                            @click="approveVoucher(0)"
                        >
                            <i class="zmdi zmdi-card mr-3"></i>
                            <span class="hidden sm:inline">{{ trans('vouchers.confirm_free_purchase') }}</span>
                            <span class="sm:hidden">{{ trans('global.continue') }}</span>
                        </ep-button>
                        <ep-button
                            v-else-if="totalPriceToPayNow > 0"
                            :loading="loading"
                            :disabled="loading"
                            @click="approveVoucher(1)"
                        >
                            <i class="zmdi zmdi-card mr-3"></i>
                            <span class="hidden sm:inline">{{ trans('vouchers.confirm_and_pay') }}</span>
                            <span class="sm:hidden">{{ trans('global.continue') }}</span>
                        </ep-button>
                        <ep-button
                            v-else
                            :loading="loading"
                            :disabled="loading"
                            @click="approveVoucher(0)"
                        >
                            <i class="zmdi zmdi-check mr-3"></i>
                            <span class="hidden sm:inline">{{ trans('vouchers.confirm_and_buy') }}</span>
                            <span class="sm:hidden">{{ trans('global.continue') }}</span>
                        </ep-button>
                    </div>
                </div>
            </card>
        </form>
    </div>
</template>
